<div class="sp-dialog__max-width-s sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding">
    <h3 class="sp-color__accent">
      {{ 'AUTH.FORGOT_PSS_TITLE' | translate }}
    </h3>
    <p class="sp-margin__top-x2">
      {{ 'AUTH.FORGOT_PSS_SUBTITLE' | translate }}
    </p>

    <form
      [formGroup]="pss_reset_from_group"
      class="sp-margin__top-x2">
      <mat-form-field
        class="sp-width__full sp-form-field sp-margin__bottom-x4"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'GENERAL.EMAIL_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="email"
          formControlName="email"
          [errorStateMatcher]="error_matcher"
          required />
      </mat-form-field>

      <app-shared-button
        class="sp-width__full"
        [button_class]="'sp-button__main'"
        [spinner_class]="'sp-spinner__main'"
        [cta]="'GENERAL.CONFIRM_CTA'"
        [is_disabled]="!isFormValid() || is_pss_request_running"
        [is_spinner_visible]="is_pss_request_running"
        (click)="onPssRequestClick()"></app-shared-button>
    </form>
  </div>
</div>
